import React from "react";
import { Link } from "react-router-dom";
import "./programmes.scss";
export const ResearchProgrammes = () => {
  return (
    <>
      {" "}
      <div className="programmes">
        <center>
          <h1>RESEARCH PROGRAMMES</h1>
        </center>
        <div className="flexy flexyM offset-md-5 mt5">
          {" "}
          <Link to={"/"} className="home-link">
            HOME
          </Link>
          <span>
            <i class="icofont-rounded-right"></i>
          </span>
          <h6>Research</h6>
        </div>
      </div>
      <div className="col-md-8 offset-md-2 mtt">
        <p>
          The Laboratory has a number of formal collaborations with Industrial
          Partners, with International Organisations and with Formal
          Partnerships within the University. The details of the current
          collaborative programmes are given below.
        </p>
        <div className="flexy flexyM">
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img"> </div>
            <div className="col-md-6 research-detail">
              <h6>Nigeria Nuclear Energy Center</h6>
              <Link
                to={"/research-programmes"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img2"> </div>
            <div className="col-md-6 research-detail">
              <h6>Research Programmes</h6>
              <Link
                to={"/research-programmes"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
        </div>{" "}
        <div className="flexy flexyM mt4">
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img"> </div>
            <div className="col-md-6 research-detail">
              <h6>Computational Radiotherapy Collaborations</h6>
              <Link
                to={"/research-programmes"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
          <div className="col-md-6 research-links flexy flexyM">
            <div className="col-md-5 research-img2"> </div>
            <div className="col-md-6 research-detail">
              <h6>Programme for the Physics of Sustainability</h6>
              <Link
                to={"/research-programmes"}
                className="offset-md-8 research-arrow"
              >
                <i class="icofont-circled-right"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
